import {
  OrganizationApplicationStatusEnum,
  ReviewOrgData,
  ReviewOrgDataApplicationStatus,
  ReviewOrgDataApplicationUpdated,
} from '@platform/client/schemas';
import {
  ProfileSection,
  ProfileItem,
  ProfileItemLong,
  ProfileLinkExternal,
  ProfileTabContainer,
  ProfileValueColors,
} from '../../components/ProfileComponents';
import { dateToDaysAgoString } from '../../../util/DateHelpers';

export const ProfileTabContent = ({ organizationData }: { organizationData?: ReviewOrgData }) => {
  if (!organizationData) {
    return <div>No organization data available.</div>;
  }
  return (
    <ProfileTabContainer>
      <ProfileSection>
        <ProfileItem label='City' value={organizationData.city} />
        <ProfileLinkExternal label='Website' href={organizationData.website} />
        <ProfileItem label='Country' value={organizationData.country} />
        <ProfileLinkExternal label='LinkedIn' href={organizationData.linkedin} />
        <ProfileItem label='Organization Size' value={organizationData.size} />
        <ProfileItem label='Impact Tracking' value={organizationData.impactTracking} />
        <ProfileItem label='Founded' value={organizationData.registrationDate?.toString()} />
        <ProfileItem
          label='Generating Revenue'
          value={organizationData.generatingRevenue ? `${organizationData.revenueAmount}` : 'No'}
        />
        <ProfileItem label='Corporate Client' value={organizationData.corporateClient} />
        <ProfileItem label='Organization Type' value={organizationData.type} />
        <ProfileItemLong
          label='Impact Partners'
          value={organizationData.partners.map((partner) => partner).join(', ')}
        />
        <ApplicationStatusItem
          applicationStatus={organizationData.applicationStatus}
          applicationStatusDate={organizationData.applicationUpdated}
        />
      </ProfileSection>
      <ProfileSection columns={1}>
        <ProfileItemLong label='Operates In' value={organizationData.countries?.join(', ')} />
        <ProfileItemLong label='Industries' value={organizationData.industries.join(', ')} />
        <ProfileItemLong label='SDGs' value={organizationData.causes.join(', ')} />
        {organizationData.businessProblem && <ProfileItemLong label='Problem Statement' value={organizationData.businessProblem} />}
        {organizationData.businessSolution && <ProfileItemLong label='Solution Statement' value={organizationData.businessSolution} />}
        {organizationData.description && <ProfileItemLong label='Description' value={organizationData.description} />}
        {organizationData.impactStory && <ProfileItemLong label='Impact Story' value={organizationData.impactStory} />}
      </ProfileSection>
      <ProfileSection columns={1}>
        <ProfileItemLong
          label='Challenge One'
          value={`${organizationData.challengeOne} - ${organizationData.contextOne}`}
        />
        <ProfileItemLong
          label='Challenge Two'
          value={`${organizationData.challengeTwo} - ${organizationData.contextTwo}`}
        />
        <ProfileItemLong
          label='Challenge Three'
          value={`${organizationData.challengeThree} - ${organizationData.contextThree}`}
        />
      </ProfileSection>
    </ProfileTabContainer>
  );
};

const ApplicationStatusItem = ({
  applicationStatus,
  applicationStatusDate,
}: {
  applicationStatus?: ReviewOrgDataApplicationStatus;
  applicationStatusDate?: ReviewOrgDataApplicationUpdated;
}) => {
  let value = '';
  let color: ProfileValueColors = 'default';
  if (applicationStatus) {
    value = applicationStatus;
    if (applicationStatus === OrganizationApplicationStatusEnum.pending && applicationStatusDate) {
      value += ` (${dateToDaysAgoString(applicationStatusDate)})`;
      color = 'warning';
    } else if (
      applicationStatus === OrganizationApplicationStatusEnum.rejected ||
      applicationStatus === OrganizationApplicationStatusEnum.deactivated
    ) {
      color = 'error';
    } else if (applicationStatus === OrganizationApplicationStatusEnum.approved) {
      color = 'success';
    }
  }
  return <ProfileItem label='Application Status' value={value} color={color} />;
};
